import localhost from "apis/localhost";
import { modalTypes } from "constants/types";
import { showErrorModal } from "slices/app/actions/error";
import { hideModal, showModal } from "slices/app/actions/modals";
import {
  addToJobQueue,
  clearJobQueue,
  showGlobalAlert,
} from "slices/app/appSlice";
import { alertVariants } from "@visiblethread/react-components/dist/components/Alert";
import { licenseSetupConfirmationModal } from "components/Modal/confModalTypes";
import { setLicenseInfo } from "slices/systemAdmin/systemAdminSlice";

export const fetchLicenseInfo = () => async (dispatch) => {
  await localhost
    .get("/docs/systemAdmin/license")
    .then(async (response) => {
      const { data } = response;
      dispatch(setLicenseInfo(data));
    })
    .catch((error) => {
      dispatch(showErrorModal(error));
    })
    .finally(() => {
      dispatch(clearJobQueue());
    });
};

export const uploadLicense = (formData) => async (dispatch) => {
  dispatch(addToJobQueue("genericJob"));

  await localhost
    .post("/docs/systemAdmin/license", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then(async (response) => {
      const { data } = response;
      dispatch(setLicenseInfo(data.licenseInfo));
      dispatch(hideModal(modalTypes.IMPORT_FILE));
      dispatch(
        showGlobalAlert({
          variant: alertVariants.success,
          text: data.successMessage,
        })
      );
    })
    .catch((error) => {
      dispatch(hideModal(modalTypes.IMPORT_FILE));
      dispatch(showErrorModal(error));
    })
    .finally(() => {
      dispatch(clearJobQueue());
    });
};

export const licenseSetup = (formData) => async (dispatch) => {
  dispatch(addToJobQueue("genericJob"));

  await localhost
    .post("/docs/systemAdmin/setupLicense", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then(async () => {
      const redirectToLogin = () => {
        window.location.href = "/";
      };

      dispatch(
        showModal(
          modalTypes.CONFIRMATION,
          licenseSetupConfirmationModal(dispatch, redirectToLogin)
        )
      );
    })
    .catch((error) => {
      dispatch(hideModal(modalTypes.NEW_USER));
      dispatch(showErrorModal(error));
    })
    .finally(() => {
      dispatch(clearJobQueue());
    });
};
